import React from 'react';
import styles from './NotFound.module.scss';
import { SFBlue, SFButton, SFIcon } from 'sfui';
import { useNavigate } from 'react-router-dom';

export interface NotFoundProps {}

export const NotFound = (
  props: NotFoundProps
): React.ReactElement<NotFoundProps> => {
  const navigate = useNavigate();

  return (
    <div className={styles.notFound}>
      <SFIcon icon="Question-App" size={96} color={SFBlue[500]} />

      <h1>
        We could not find <br /> this page.
      </h1>

      <SFButton
        size="large"
        variant="outlined"
        onClick={() => navigate('/', { replace: true })}
      >
        Go to Home
      </SFButton>
    </div>
  );
};
